import api from './client';

export const salesApi = {
  list:           (params?: any) => api.get('/sales', { params }),
  quickSale:      (data: any)    => api.post('/sales/quick', data),
  invoiceSale:    (data: any)    => api.post('/sales/invoice', data),
  receivePayment: (data: any)    => api.post('/sales/payment', data),
  get:            (id: number)   => api.get(`/sales/${id}`),
};
